import { isDev } from "@/config/env";

import { KAKAO_SHARE_FORCE_FEED } from "../kakao.config";
import { logDeckCardKakaoShareImage } from "../logDeckCardKakaoShareImage";
import { initKakaoSdk } from "../initKakaoSdk";
import type {
  DeckCardKakaoShareInput,
  DeckCardKakaoShareLabels,
} from "../kakao.types";
import { buildDeckCardKakaoPayload } from "./buildDeckCardKakaoPayload";

/**
 * Opens the KakaoTalk share picker for app-deck cards (single, demo, LT, season).
 * Uses REACT_APP_KAKAO_FAN_CARD_TEMPLATE_ID; otherwise falls back to Feed.
 */
export const shareDeckCardToKakao = async (
  input: DeckCardKakaoShareInput,
  labels?: DeckCardKakaoShareLabels,
): Promise<void> => {
  const Kakao = await initKakaoSdk();
  const payload = buildDeckCardKakaoPayload(input, labels);

  logDeckCardKakaoShareImage({
    mainCardId: input.mainCardId,
    coverImageUrlInput: input.coverImageUrl,
    imageUrlInput: input.imageUrl,
    kakaoImageUrlResolved: payload.imageUrl,
    templateImageUrl: payload.templateArgs.image_url ?? payload.imageUrl,
    thumbnailSources: input.thumbnailSources,
  });

  if (isDev && typeof window !== "undefined") {
    console.info("[Kakao share] payload (4019 = caller/link domain not in Kakao console):", {
      caller: window.location.origin,
      shareUrl: payload.shareUrl,
      templateId: payload.custom?.templateId ?? null,
      forceFeed: KAKAO_SHARE_FORCE_FEED,
    });
  }

  const customPayload = payload.custom;

  if (customPayload && !KAKAO_SHARE_FORCE_FEED) {
    Kakao.shareClient.sendCustom(customPayload);
    return;
  }

  Kakao.shareClient.sendDefault(payload.feed);
};
